import { Component, ViewEncapsulation } from '@angular/core';

import { DialogRef, ModalComponent} from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';

import {FraudReportEntries} from './fraud-report-entries';
import {TransactionLogManagementTableComponent} from '../transaction-log/transaction-log-management-table.component';


export class FraudReportsContext extends BSModalContext {
    public fraudReportEntry : any;

}
@Component({
    
    template: require('./fraud-reports-modal-template.html'),
    styles: [`
    
     .modal-header, .modal-body, .modal-footer {
         color:#404040;
     }
         .custom-modal-container {
             padding: 15px;
         }
 
         .custom-modal-header {
             background-color: #219161;
             color: #fff;
             -webkit-box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);
             -moz-box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);
             box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);
             margin-top: -15px;
             margin-bottom: 40px;
         }
 
         .onoffswitch {
             position: relative; width: 78px;
             -webkit-user-select:none; -moz-user-select:none; -ms-user-select: none;
         }
         .onoffswitch-checkbox {
             display: none;
         }
         .onoffswitch-label {
             display: block; overflow: hidden; cursor: pointer;
             height: 24px; padding: 0; line-height: 24px;
             border: 2px solid #999999; border-radius: 24px;
             background-color: #EEEEEE;
             transition: background-color 0.3s ease-in;
         }
         .onoffswitch-label:before {
             content: "";
             display: block; width: 24px; margin: 0px;
             background: #FFFFFF;
             position: absolute; top: 0; bottom: 0;
             right: 52px;
             border: 2px solid #999999; border-radius: 24px;
             transition: all 0.3s ease-in 0s; 
         }
         .onoffswitch-checkbox:checked + .onoffswitch-label {
             background-color: #5bc0de;
         }
         .onoffswitch-checkbox:checked + .onoffswitch-label, .onoffswitch-checkbox:checked + .onoffswitch-label:before {
         border-color: #5bc0de;
         }
         .onoffswitch-checkbox:checked + .onoffswitch-label:before {
             right: 0px; 

             
         }
          
         @media (min-device-width: 768px){

            .modal-lg {
                position: absolute;
                display: block;
                width: 1000px;
                left: -120px;
             
            }

         }

         }
    
         


     `],
    providers:[Modal],
    selector: 'fraud-content'
})
export class FraudReportModalComponent implements ModalComponent<FraudReportsContext> {
    context: FraudReportsContext;

    constructor(
        public dialog: DialogRef<FraudReportsContext>,
        public modal: Modal
    
    ) {
        this.context = dialog.context.fraudReportEntry;
        console.log(dialog.context.fraudReportEntry);  
    }

    closeDialog() {
        this.dialog.close();
    }

}

 

    

    
  

    
 



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/fraud-reports/fraud-reports-modal.ts